import React from 'react';
import PersonalBestCard from './PersonalBestCard';

interface PersonalBest {
  score: number;
  date: string;
  duration_minutes?: number;
}

interface PersonalBests {
  survival_best: PersonalBest | null;
  rush_5_best: PersonalBest | null;
  rush_10_best: PersonalBest | null;
  rush_20_best: PersonalBest | null;
  rush_30_best: PersonalBest | null;
}

interface PersonalBestsSectionProps {
  personalBests: PersonalBests | null;
  isLoading: boolean;
}

const PersonalBestsSection: React.FC<PersonalBestsSectionProps> = ({
  personalBests,
  isLoading
}) => {
  if (isLoading) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-lg font-medium text-gray-900 dark:text-white">Personal Bests</h2>
        </div>
        <div className="p-6">
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-mango-500"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-lg font-medium text-gray-900 dark:text-white">Personal Bests</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Your best scores across all game modes
        </p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {/* Survival Mode */}
          <PersonalBestCard
            mode="survival"
            score={personalBests?.survival_best?.score || 0}
            date={personalBests?.survival_best?.date}
            gameLink="/survival"
          />

          {/* Rush 5 Minutes */}
          <PersonalBestCard
            mode="rush"
            duration={5}
            score={personalBests?.rush_5_best?.score || 0}
            date={personalBests?.rush_5_best?.date}
            gameLink="/rush?duration=5"
          />

          {/* Rush 10 Minutes */}
          <PersonalBestCard
            mode="rush"
            duration={10}
            score={personalBests?.rush_10_best?.score || 0}
            date={personalBests?.rush_10_best?.date}
            gameLink="/rush?duration=10"
          />

          {/* Rush 20 Minutes */}
          <PersonalBestCard
            mode="rush"
            duration={20}
            score={personalBests?.rush_20_best?.score || 0}
            date={personalBests?.rush_20_best?.date}
            gameLink="/rush?duration=20"
          />

          {/* Rush 30 Minutes */}
          <PersonalBestCard
            mode="rush"
            duration={30}
            score={personalBests?.rush_30_best?.score || 0}
            date={personalBests?.rush_30_best?.date}
            gameLink="/rush?duration=30"
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalBestsSection;
